import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { NavigationService } from '../services/navigation.service';
import { AppConfigurationService } from '../services/app-configuration.service';

@Injectable({ providedIn: 'root' })
export class IsNotInitializedGuard {
  constructor(
    private navigationService: NavigationService,
    private appConfigurationService: AppConfigurationService,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!this.appConfigurationService.noOrganizationExists) {
      await this.navigationService.navigateToDefaultPage(true);
    }
    return true;
  }
}
